// @ts-nocheck
import { Component, NgZone, OnInit, TemplateRef, ViewChild, NO_ERRORS_SCHEMA } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { PlansService } from 'src/app/services/plans.service';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { Router } from '@angular/router';
import { VendorService } from 'src/app/services/vendor.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { UtilsDataService } from 'src/app/services/utils-data.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Product } from 'src/app/shared/classes/product';
import { ProductService } from 'src/app/shared/services/product.service';
import { OrderService } from 'src/app/shared/services/order.service';
import { environment } from 'src/environments/environment';
import { InvoicesignalService } from 'src/app/shared/services/invoicesignal.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HeaderOneComponent } from '../../../shared/header/header-one/header-one.component';
import { BreadcrumbComponent } from '../../../shared/components/breadcrumb/breadcrumb.component';
@Component({
  standalone: true,
  selector: 'app-plan-detail-page',
  templateUrl: './plan-detail-page.component.html',
  styleUrl: './plan-detail-page.component.scss',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatDialogModule, HeaderOneComponent, BreadcrumbComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PlanDetailPageComponent {
  [key: string]: any;
  constructor(
    private adminService: AdminService,
    private plansService: PlansService,
    private paymentService: PaymentService,
    private winRef: WindowRefService,
    private router: Router,
    private vendorService: VendorService,
    private dialog: MatDialog,
    private authService: AuthService,
    private utilsDataService: UtilsDataService,
    private zone: NgZone,
    public productService: ProductService,
    private orderService: OrderService,
    private invoiceSignalService: InvoicesignalService
  ) {}

  ngOnInit(): void {}

  calculateTotalPlanPrice() {}

  openLoginDialog() {}

  getCompanyDetailsByVendorId() {}

  isCompanyObjectEmpty(): boolean {}

  isCityDetailsNull(): boolean {}

  initiateOrder() {}

  payWithRazor(val: any, key: any) {}

  initiateDbPlansOrder() {}

  payWithRazorDbPurchases(val: any, key: any) {}

  initiateAdvertPlansOrder() {}

  payWithRazorAdvertPurchases(val: any, key: any) {}

  initiateMatriOrder() {}

  payWithRazorMatriPurchases(val: any, key: any) {}

  goTo(link: any) {}

  freePusrchaseOrder() {}

  payNow() {}

  getDiscountLabel(rowDetails: any): string {}

  calculateGstTotal(obj:any) {}
}
